export enum ProjectsSortField {
  Name = 'name',
  ProjectNumber = 'projectnumber',
  Company = 'company',
  Status = 'status',
  DesiredStartDate = 'desiredstartdate',
  CreatedAt = 'createdat',
  Budget = 'budget'
}